import React from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import logo from '@cred/global-assets/images/logos/credible/logo-blue.svg'
import styles from './styles.scss'

const PoweredBy = ({ className }) => (
  <div className={className}>
    <Font type="bodySmall" className={styles.text}>
      Powered by&nbsp;
      <img src={logo} className={styles.logo} alt="Credible" />
    </Font>
  </div>
)

PoweredBy.propTypes = {
  className: PropTypes.string,
}

export default PoweredBy
